export enum BulkFeatureKey {
  SRP = 'SRP',
  BOOKMARKS = 'BOOKMARKS',
  LIBRARY_LIST = 'LIBRARY_LIST',
}
